import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import souvenirsDate from "../../datebase/souvenirsDate"
import "./souvenirs.css"
import { Link, useParams } from "react-router-dom";
const Souvenirs = ({ t, langcat, Swiper, SwiperSlide, Navigation, Pagination, Mousewheel, Autoplay }) => {
    return (
        <>
            <div className="souvenirs">
                <div className="container">
                    <Swiper
                        className="SouvenirsSwiper"
                        modules={[Navigation, Pagination, Mousewheel, Autoplay]}
                        spaceBetween={20}
                        slidesPerView={4}
                        navigation={{
                            nextEl: '.swiper-button-next-custom',
                            prevEl: '.swiper-button-prev-custom',
                        }}
                        pagination={{ clickable: true }}
                        mousewheel
                        grabCursor
                        loop={true} // 🔁 делает слайды бесконечными
                        autoplay={{
                            delay: 3000, // ⏱ задержка между сменой слайдов (в мс)
                            disableOnInteraction: true, // 👆 продолжает после ручного скролла
                        }}
                        breakpoints={{
                            320: { slidesPerView: 1 },
                            768: { slidesPerView: 2 },
                            1024: { slidesPerView: 3 },
                        }}
                    >
                        <div className="swiper-button-prev-custom"><i class="fa fa-chevron-left" aria-hidden="true"></i></div>
                        <div className="swiper-button-next-custom"><i class="fa fa-chevron-right" aria-hidden="true"></i></div>
                        {souvenirsDate.map((koks) => {
                            if (koks.tourlang === langcat && koks.id >= 1) {
                                return (
                                    <SwiperSlide key={koks.id}>
                                        <div className="souvenirs-box">

                                            <div className="souvenirs-box-img">
                                                <img src={`${koks.img}.jpg`} alt={koks.name} />
                                            </div>
                                            <div className="souvenirs-box-text">
                                                <span className="souvenirs-box-text-name">
                                                    {koks.name}
                                                </span>
                                                <span className="souvenirs-box-text-price">
                                                    {koks.price}$
                                                </span>
                                            </div>
                                            <div className="souvenirs-box-price">
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                );
                            }
                            return null;
                        })}
                    </Swiper>
                </div>
            </div>
        </>
    )
}
export default Souvenirs;